// components
import { Button } from '@centria-ui-atoms/button'
import { Card } from '@centria-ui-atoms/card'
import { AuthHeroQuote } from '../quote'

// styles
import classes from './styles.module.scss'

// types
import type { AuthHeroQuoteProps } from '../quote'
import type { StaticImageData } from 'next/image'
import type { FC } from 'react'

type MobileHeroProps = {
  backgroundImage: StaticImageData
  quote?: AuthHeroQuoteProps
  action: {
    label: string
    action: () => void
  }
}

export const MobileHero: FC<MobileHeroProps> = ({
  quote,
  action,
  backgroundImage
}) => {
  const overlayTemplate = () => (
    <Button onClick={action.action} className={classes.button}>
      {action.label}
    </Button>
  )

  return (
    <Card
      className={classes.mobile}
      cardImage={backgroundImage.src}
      cardOverlay={overlayTemplate()}
      cardBody={<AuthHeroQuote {...quote} />}
    />
  )
}
